<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style=";margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <v-card v-if="child_data!=null" class="box">
      <v-card-text>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong>
              Get Time Table
            </strong>
          </v-toolbar-title>
        </v-toolbar>
        <!-- <h3>Get Time Table</h3>
            <br> -->
        <v-col cols="12" sm="12" md="12">
          <v-simple-table dense class="elevation-1 mytable">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <center>Name</center>
                  </th>
                  <th class="text-left">
                    <center>PRN No</center>
                  </th>
                  <th class="text-left">
                    <center>Roll no</center>
                  </th>
                  <th class="text-left">
                    <center>Std</center>
                  </th>
                  <th class="text-left">
                    <center>Div</center>
                  </th>
                  <th class="text-left">
                    <center>Action</center>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="child in child_data" :key="child.id">
                  <td>
                    <center>{{ child.name }}</center>
                  </td>
                  <td>
                    <center>{{ child.grno }}</center>
                  </td>
                  <td>
                    <center>{{ child.rollno }}</center>
                  </td>
                  <td>
                    <center>{{ child.std }}</center>
                  </td>
                  <td>
                    <center>{{ child.div }}</center>
                  </td>
                  <td>
                    <center><v-btn class="button"
                        @click="show_tt=true;div_off_id=child.div_off_id;curr_lid=child.lid">View</v-btn></center>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <!-- <v-row justify="center" dense v-for="child in child_data" :key="child.id">
          <v-col sm="2">
              {{child.name}}
          </v-col>
           <v-col sm="2">
              {{child.grno}}
          </v-col>
            <v-col sm="2">
              {{child.rollno}}
          </v-col>         
          <v-col sm="2">
              {{child.div_off_id}}
          </v-col>                   
        </v-row> -->
      </v-card-text>
    </v-card>
    <br>
    <div-time-table v-if="show_tt==true" :curr_lid="curr_lid" :div_id="div_off_id"></div-time-table>
     <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Child Time Table Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/SEQWbaTrPvo?si=OyxArLIuoVeE_X-J"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import DivTimeTable from './DivTimeTable'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    name: "DivTimeTable",
components:{
  'div-time-table': DivTimeTable,
  Breadcrumbs
},
  data() {
    return {
      show_tt:false,
        child_data:null,
        videoDialog:false,
        div_off_id:null,
      curr_lid: null,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
    };
  },
  methods:{
  },
  mounted() {
    this.show_tt=false
    axios
        .post("/commonAPI/getChildDataTT")
        .then(res => {
           this.child_data = res.data.child_data
        })
        .catch(error => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
            //stop loader 
        });
  }
}
</script>